import { MovieClip } from '@play-co/timestep-core/ui';
import { Container, Texture } from '../../../odie';
import { getMatch2AssetPath } from '../../util/assets';
import { blockPositionView } from '../../util/blockTools';
import { RainbowSoapBlockProps } from './RainbowSoapBlock';
import { CountBlockOptionDef } from '../../defs/block';
import { RainbowBubbleBlockView } from '../../views/blocks/RainbowBubbleBlockView';

const manifest = () => ({
  movieclip: {
    url: getMatch2AssetPath('blocks/rainbowSoap'),
    loadMethod: MovieClip.animationLoader,
  },
});

export class RainbowSoapBlockView extends Container {
  private movieclip: MovieClip;

  constructor(props: RainbowSoapBlockProps) {
    super();
    blockPositionView(this, props);
    this.movieclip = new MovieClip({
      superview: this.view,
      url: manifest().movieclip.url,
      scale: 0.9,
      defaultAnimation: 'rainbowsoap',
    });
  }

  public static assets() {
    return [...Object.values(manifest()), ...RainbowBubbleBlockView.assets()];
  }
}

export function _createRainbowSoapBlockView(
  props: RainbowSoapBlockProps,
): RainbowSoapBlockView {
  const view = new RainbowSoapBlockView(props);
  return view;
}
